// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
  dirty: true,
  raw: 'tags/v0.1.5-3393-g2d2120b3-dirty',
  hash: 'g2d2120b3',
  distance: 3393,
  tag: 'tags/v0.1.5',
  semver: null,
  suffix: '3393-g2d2120b3-dirty',
  semverString: '',
  version: '1.49.0',
};
/* tslint:enable */
